import React from 'react'

import { classes } from '../utils'

type Props = {
  /** Provide the children that will be rendered inside the toolbar with the standard
   *  container styles throughout the Portal */
  padded?: boolean
  /** The border style of the toolbar */
  border?: 'full' | 'x' | 'y' | 'custom' | 'none'
  /** Optional classes to apply to the inner container */
  innerClassName?: string
} & React.HTMLAttributes<HTMLDivElement>

/**
 * A generic container for creating uniform, toolbar components
 */
export default function ToolBar({
  className,
  border = 'y',
  padded,
  children,
  innerClassName,
  ...props
}: Props) {
  return (
    <div
      data-testid="toolbar"
      className={classes(
        '-mb-px h-10 w-full border-solid border-border-normal bg-background',
        { 'border-y': border === 'y' },
        { 'border-x': border === 'x' },
        { border: border === 'full' },
        {
          'border-none': border === 'none',
        },
        className,
      )}
      {...props}
    >
      <div
        data-testid="toolbar-inner"
        className={classes(
          'flex h-full w-full items-center',
          {
            'mx-auto max-w-7xl px-4': padded,
          },
          innerClassName,
        )}
      >
        {children}
      </div>
    </div>
  )
}
